<cmps-population-compare
    populationCompareTitle="Population Compare"
    selectGroupLabel="Select the group"
    selectSubgroupLabel="Select the subgroup"
    searchLabel="Search..."
    groupsToCompareLabel="Groups to compare"
    subgroupLabel="Subgroup 1"
    [groupData]="cmpsGroupData"
    resetLabel="Reset"
    compareLabel="Compare"
    (compareAction)="_onCompareAction($event)"
></cmps-population-compare>
